import  { createContext, useContext, useState } from 'react';
import React from "react"
type BottomBarContextType = {
  element: React.ReactNode;
  elementLeft: React.ReactNode;
  setElement: (element: React.ReactNode) => void;
  setElementLeft: (element: React.ReactNode) => void;
};

const BottomBarContext = createContext<BottomBarContextType>({
  element: null, 
  elementLeft:null,
  setElement: () => {},
  setElementLeft: () => {}
});

export const useBottomBar = () => useContext(BottomBarContext);

export const BottomBarProvider: React.FC<{children: React.ReactNode}> = ({children}) => {
  const [element, setElement] = useState<React.ReactNode>(null);
  const [elementLeft, setElementLeft] = useState<React.ReactNode>(null);

  return (
    <BottomBarContext.Provider value={{ element, setElement,elementLeft,setElementLeft, }}>
      {children}
    </BottomBarContext.Provider>
  );
};
